import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import { IDocUploaderForm } from '@/shared/store/doc-uploader/types';
import { isExpiresLocked } from '@/shared/store/doc-uploader/upload-form';
import { DateField } from '@src-common/view/adapters/DateField';

import { TOnChangeValue } from './DocUploadBlock';
import { getExpiryValidation } from './expiry-validation';

interface IProps<TDocType> {
  form: IDocUploaderForm<TDocType>;
  onChangeValue: TOnChangeValue<TDocType>;
  isExpires?: boolean;
  isUploading: boolean;
  testId?: string;
}

const ExpiresAtField = <TDocType extends string>({
  form,
  onChangeValue,
  isExpires,
  isUploading,
  testId = 'dialog__expires-at',
}: IProps<TDocType>) => {
  const intl = useIntl();
  const [isTouched, setIsTouched] = useState(false);

  const handleChange = useCallback<TOnChangeValue<TDocType>>(
    (event, params) => {
      setIsTouched(true);
      onChangeValue(event, params);
    },
    [onChangeValue],
  );

  if (!isExpires) {
    return null;
  }

  const isLocked = isExpiresLocked(form);

  return (
    <div data-test-id={testId}>
      <DateField
        title={intl.formatMessage({
          defaultMessage: 'EXPIRES AT',
          id: 'e8Rq20',
          description: 'Upload form: input title',
        })}
        isDisabled={isUploading || isLocked}
        name={'expiresAt'}
        value={form.expiresAt ?? null}
        onChange={handleChange}
        error={
          isTouched && !isLocked ? getExpiryValidation(intl, isExpires, form.expiresAt) : undefined
        }
      />
    </div>
  );
};

export { ExpiresAtField };
